import React from 'react';
import moment from 'moment';

//Icon
/*import iconMaping from '../../../../utils/IconMaping.js';*/

export default class BookingRow extends React.Component {
  /*constructor(props) {
    super(props);
  }*/

  renderLabelStatus() {
    let status = this.props.RowData.Status;

    if(status === 'canceled') {
      return(<strong title="status Booking" className="btn-badge s-booked-canceled cursor-default">{this.props.RowData.Status}</strong>)
    } 
    else if(status === 'ongoing'){
        return(<strong title="status Booking" className="btn-badge s-booked-ongoing">{this.props.RowData.Status}</strong>)
    } 
    else {
      return(<strong title="status Booking" className="btn-badge s-booked cursor-default">{this.props.RowData.Status}</strong>)
    }
  }

  render() {
    return (
      <tr onClick={()=>this.props.toggleModalDetail(this.props.RowData.Asset)} role="button">
        <td>
          <div>
            <strong role="button" className="spaceR">{this.props.RowData.Asset.Name}</strong>(<span>{this.props.RowData.Asset.Alias}</span>)
          </div>
        </td>
        <td className="text-center">
          <span>{this.props.RowData.User.FirstName}</span>&nbsp;<span>{this.props.RowData.User.LastName}</span>
          <div className="text-muted">
            <small><span>Username:</span>&nbsp;<span>({this.props.RowData.User.Username})</span></small>
          </div>
        </td>
        <td>
          <span>{this.props.RowData.Site.Name}</span>
        </td>
        <td>
          <span>{this.props.RowData.Location.Name}</span>
        </td>
        <td className="text-center">
          <span>{moment(this.props.RowData.StartDate).format('ll')}</span>
        </td>
        <td className="text-center">
          <span>{moment(this.props.RowData.FinishDate).format('ll')}</span>
        </td>
        <td className="text-center">
          <div className="text-muted">
            {this.renderLabelStatus()}
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/booking/helper/component/BookingList/BookingRow.js